/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { action } from 'typesafe-actions';

import { CategoryActionTypes, CategoryData, HeroBannerData } from './types';

export function findCategoryRequest() {
  return action(CategoryActionTypes.LOAD_REQUEST);
}

export function findCategorySuccess(data: CategoryData[]) {
  return action(CategoryActionTypes.LOAD_SUCCCES, {
    data,
  });
}

export function findCategoryFailure() {
  return action(CategoryActionTypes.LOAD_FAILURE);
}

export function setSubcategories(data: CategoryData[]) {
  return action(CategoryActionTypes.SET_SUBCATEGORIES, {
    data,
  });
}

export function setCategorySelected(categoryId: string) {
  return action(CategoryActionTypes.SET_CATEGORY_SELECTED, {
    categoryId,
  });
}

export function setSubCategorySelected(subcategoryId: string) {
  return action(CategoryActionTypes.SET_SUBCATEGORY_SELECTED, {
    subcategoryId,
  });
}

export function resetCategoriesSelected() {
  return action(CategoryActionTypes.RESET_CATEGORIES_SELECTED);
}

export function searchComponents(categoryId: string | null) {
  return action(CategoryActionTypes.SEARCH_COMPONENTS, {
    categoryId: categoryId || '',
  });
}

export function searchComponentsResponse(categoryId: string, data: HeroBannerData[]) {
  return action(CategoryActionTypes.SEARCH_COMPONENTS_RESPONSE, {
    categoryId,
    data,
  });
}

export function searchComponentsAlreadyExist(categoryId: string) {
  return action(CategoryActionTypes.SEARCH_COMPONENTS_ALREADY_EXIST, {
    categoryId,
  });
}